<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <component :growerId="growerId" :is="component"></component>
    </div>
</template>

<script>
import currentUserQuery from '@views/GrowerChemicals/Container/queryCurrentUser.graphql';
import ContractorBrowse from './ContractorBrowse';

export default {
  name: 'GrowerChemicalsContainer',
  props: ['growerId'],
  components: {
    ContractorBrowse,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['contractor'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
  computed: {
    component() {
      if (!this.currentUser) {
        return null;
      }

      switch (this.currentUser.role.name) {
        case 'contractor':
          return ContractorBrowse;
      }
    },
  },
};
</script>
